<template>
  <PageContainer>
    <template #title>
      <span>
        {{ $t('xiao-hao-ji-lu') }}
        <a-tooltip
          v-if="openTip"
          placement="right"
          :title="$t('ci-chu-cha-kan-he-shi-xiao-hao-yan-bi')"
          color="var(--primary-color)"
          destroyTooltipOnHide
          open
        >
          <InfoCircleOutlined class="ml-[6px] text-14 cursor-pointer" />
        </a-tooltip>
        <InfoCircleOutlined
          v-if="!openTip && isChinese()"
          class="ml-[6px] text-14 cursor-pointer"
          @click="useConsumeTip()"
        />
      </span>
    </template>
    <template #pageExtra>
      <span v-if="total" class="text-14 font-normal">
        {{ $t('zong-xiao-hao-yan-bi') }}：{{ total || '-' }}
      </span>
    </template>
    <Purchase
      :userId="userInfo?.user_id"
      scrollY="calc(100vh - 400px)"
      :pageSize="20"
      @total="onTotal"
    />
  </PageContainer>
</template>
<script lang="ts" setup>
import Purchase from './components/purchase.vue'
import { useConsumeTip } from '~/hooks/useModal/modals/consume'

const CONSUME_TIP = 'youyan_center_consume_tip'
const openTip = ref(false)
const total = ref(0)

const onTotal = (data?: number) => {
  total.value = data || 0
}

const userInfo = useUserInfo()
const runtime = useRuntimeConfig()

onMounted(() => {
  const hasTip = localStorage.getItem(CONSUME_TIP)
  if (!hasTip) {
    openTip.value = true
    localStorage.setItem(CONSUME_TIP, new Date().toLocaleString())
    setTimeout(() => {
      openTip.value = false
    }, 3000)
  } else {
    openTip.value = false
  }
})
</script>
<style lang="scss" scoped></style>
